import * as React from "react";
import {css, Theme} from "@emotion/react";

import {pb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    title: string;
    className?: string;
}

export const DetailViewHeader = (props: IProps) => {
    return (
        <Text variant="headline_4" as="h2" className={props.className} css={headingStyle}>
            {props.title}
        </Text>
    );
};

const headingStyle = (theme: Theme) => css`
    ${pb(3)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${pb(4)};
    }
`;
import * as React from "react";
import {css, Theme} from "@emotion/react";

import {pb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    title: string;
    className?: string;
}

export const DetailViewHeader = (props: IProps) => {
    return (
        <Text variant="headline_4" as="h2" className={props.className} css={headingStyle}>
            {props.title}
        </Text>
    );
};

const headingStyle = (theme: Theme) => css`
    ${pb(3)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${pb(4)};
    }
`;
